"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const slate_1 = require("slate");
const OmniMenu_1 = require("./OmniMenu");
class OmniState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.open = ui_1.rsync.val(false);
        this.mode = ui_1.rsync.val('caret');
        /** Anchor point captured at open time. Frozen so the popup does not jitter
         * if the caret moves while the user navigates the menu. */
        this.point = ui_1.rsync.val(undefined);
        /** Snapshot of the editor selection at the moment the menu opens. Used to
         * paint an "active selection" decoration while the menu has focus, and to
         * detect that the cursor has moved (which closes the menu). */
        this.rangeSnapshot = ui_1.rsync.val(null);
        this.start = () => () => { };
        this.close = () => {
            if (!this.open.value)
                return;
            this.open.set(false);
            this.point.set(undefined);
            this.rangeSnapshot.set(null);
            this.mutxt.api.focus();
        };
        this.openAtCaret = () => {
            const point = this.mutxt.api.focusPoint();
            if (!point)
                return false;
            this.captureSelection();
            this.mode.set('caret');
            this.point.set(point);
            this.open.set(true);
            return true;
        };
        this.openAsPalette = () => {
            const shellBox = this.mutxt.shellBox.value;
            if (!shellBox)
                return false;
            const [x, y, width] = shellBox;
            const point = {
                x: x + width / 2,
                y: y,
                dx: 0,
                dy: 1,
            };
            this.captureSelection();
            this.mode.set('palette');
            this.point.set(point);
            this.open.set(true);
            return true;
        };
        this.openSmart = () => {
            const { mutxt, open } = this;
            if (mutxt.readOnly.value)
                return false;
            if (open.value)
                return false;
            const sel = mutxt.editor.selection;
            if (sel)
                return this.openAtCaret();
            return this.openAsPalette();
        };
        this.handleSpaceKey = () => {
            const { mutxt, open } = this;
            if (mutxt.readOnly.value)
                return false;
            if (open.value)
                return false;
            if (mutxt.selection.value)
                return this.openSmart();
            if (this.isCaretInEmptyBlock())
                return this.openSmart();
            return false;
        };
        this.menu = new OmniMenu_1.OmniMenu(mutxt);
    }
    // ------------------------------------------------------------------ Helpers
    captureSelection() {
        this.rangeSnapshot.set(this.mutxt.selection.value);
    }
    isCaretInEmptyBlock() {
        const editor = this.mutxt.editor;
        const sel = editor.selection;
        if (!sel || !slate_1.Range.isCollapsed(sel))
            return false;
        try {
            const [match] = slate_1.Editor.nodes(editor, {
                match: (n) => slate_1.Element.isElement(n) && slate_1.Editor.isBlock(editor, n),
                mode: 'lowest',
            });
            if (!match)
                return false;
            const [block] = match;
            return slate_1.Node.string(block) === '';
        }
        catch {
            return false;
        }
    }
}
exports.OmniState = OmniState;
